import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { LightGreenBtn, OrangeBtn } from '../../../../newComponents/Button/ButtonSkin';
import titleBorderSingle from '../../../../assets/newAssets/title-border-single.svg';
import listLeaf from '../../../../assets/newAssets/icons/list-leaf.svg';
import chartImage from '../../../../assets/newAssets/charts.svg';
import { useSelector } from 'react-redux';

import { Benefits } from './Styles';

const Membership = () => {
    const { selectedLanguage } = useSelector(storeState => storeState.Languages);
    const currentRole = useSelector(
        s => (s.user && s.user.currentUser && s.user.currentUser.currentRole) || 'friend'
    );
    const isPartner = currentRole === 'partner';

    const history = useHistory();
    const FRIEND_CALC_URL = '/people/personal-footprint-calculator';

    const handleCalculateClick = e => {
        e.preventDefault();

        if (isPartner) {
            history.push('/organisation/calculator');
            return;
        }

        if (/^https?:\/\//i.test(FRIEND_CALC_URL)) {
            window.open(FRIEND_CALC_URL, '_blank', 'noopener,noreferrer');
        } else {
            history.push(FRIEND_CALC_URL);
        }
    };

    return (
        <Benefits listLeaf={listLeaf}>
            <div className="two-cols flex justify-start items-center mx-auto">
                <div className="Benefits-info flex flex-col">
                    <div className="title-box">
                        <h3>
                            <FormattedMessage id="NewLandingPage.benefits.title" />
                        </h3>
                        <img src={titleBorderSingle} alt="border" />
                        <div className="description">
                            <p>
                                <FormattedMessage id="NewLandingPage.benefits.description" />
                            </p>
                        </div>
                    </div>
                    <div className="list-of-benefits flex flex-col">
                        <ul className="flex flex-col">
                            <li>
                                <FormattedMessage id="NewLandingPage.benefits.bullets.footprint" />
                            </li>
                            <li>
                                <FormattedMessage id="NewLandingPage.benefits.bullets.action" />
                            </li>
                            <li>
                                <FormattedMessage id="NewLandingPage.benefits.bullets.certify" />
                            </li>
                            <li>
                                <FormattedMessage id="NewLandingPage.benefits.bullets.updates" />
                            </li>
                            <li>
                                <FormattedMessage id="NewLandingPage.benefits.bullets.digital" />
                            </li>
                        </ul>
                        <OrangeBtn className="light-btn">
                            <Link to="/organizations">
                                <FormattedMessage id="NewLandingPage.benefits.Partner" />
                            </Link>
                        </OrangeBtn>
                        {/* <LightGreenBtn
                            className="light-btn"
                            as="button"
                            onClick={handleCalculateClick}
                        >
                            {isPartner ? (
                                <FormattedMessage id="NewLandingPage.benefits.calculateFootprint" />
                            ) : (
                                <FormattedMessage
                                    id="FriendsPage.CalculateFootprint.Btn"
                                    defaultMessage="Calculate footprint"
                                />
                            )}
                        </LightGreenBtn> */}
                    </div>
                </div>
                <div className="img-box">
                    <img src={chartImage} alt="membership benefits" />
                </div>
            </div>
        </Benefits>
    );
};

export default Membership;
